import { breakpoints, theme } from "@config/theme"
import styled from "styled-components"

export const Parent = styled.div`
  display: block;
  padding: 0 0 1rem;
  border-bottom: 1px solid ${theme.colors.softGrey};
  margin-bottom: 1.5rem;
  position: relative;

  @media screen and (min-width: ${breakpoints.small}) {
    padding: 1rem 0;
    border-top: 1px solid ${theme.colors.softGrey};
  }
`
